import _defineProperty from "@babel/runtime/helpers/defineProperty";
// @ts-nocheck
import { Text } from '@wix/wix-ui-tpa/cssVars';
import * as React from 'react';
import { CoreDropdownOption } from '../CoreDropdownOption';
import { st, classes } from './CoreDropdownContent.st.css';
const NOT_HOVERED_INDEX = -1;
/**
 * DropdownContent
 */
export class CoreDropdownContent extends React.PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "optionsContainerRef", null);
    _defineProperty(this, "mouseCoords", {
      screenX: -1,
      screenY: -1
    });
    _defineProperty(this, "state", {
      hoveredIndex: NOT_HOVERED_INDEX
    });
    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onOptionHover = this.onOptionHover.bind(this);
  }
  scrollToSelectedOption() {
    const {
      options,
      selectedIds
    } = this.props;
    if (!selectedIds.length || !this.optionsContainerRef) {
      return;
    }
    const selectedIndex = options.findIndex(option => option.id === selectedIds[0]);
    if (selectedIndex === -1) {
      return;
    }

    // Use requestAnimationFrame to ensure DOM is ready (important for portals)
    requestAnimationFrame(() => {
      if (!this.optionsContainerRef) {
        return;
      }
      const selectedOption = this.optionsContainerRef.childNodes[selectedIndex];
      if (!selectedOption) {
        return;
      }
      const parentRect = this.optionsContainerRef.getBoundingClientRect();
      const selectedRect = selectedOption.getBoundingClientRect();

      // Scroll if selected option is below the visible area
      if (selectedRect.bottom > parentRect.bottom) {
        this.optionsContainerRef.scrollTop = Math.min(selectedOption.offsetTop + selectedOption.clientHeight / 2 - this.optionsContainerRef.offsetHeight / 2, this.optionsContainerRef.scrollHeight);
      }
      this.setHoveredIndex(selectedIndex);
    });
  }
  componentDidMount() {
    const {
      focusOnOption
    } = this.props;
    this.scrollToSelectedOption();
    if (!this.props.selectedIds.length && focusOnOption) {
      this.hoverItemById(focusOnOption);
    }
  }
  componentDidUpdate(prevProps) {
    const {
      focusOnOption,
      selectedIds
    } = this.props;
    if (selectedIds.length && (!prevProps.selectedIds.length || selectedIds[0] !== prevProps.selectedIds[0])) {
      this.scrollToSelectedOption();
    }
    if (focusOnOption !== prevProps.focusOnOption) {
      this.hoverItemById(focusOnOption);
    }
  }
  setHoveredIndex(index) {
    this.setState({
      hoveredIndex: index
    }, this.onOptionHover);
  }
  onOptionHover() {
    if (this.props.onOptionHover) {
      this.props.onOptionHover(this.getSelectedOption());
    }
  }
  isValidOptionForSelection(option) {
    return option.isSelectable && !option.isDisabled;
  }
  hoverNextItem(interval) {
    const {
      options
    } = this.props;
    if (!options.find(this.isValidOptionForSelection)) {
      return;
    }
    let {
      hoveredIndex
    } = this.state;
    // eslint-disable-next-line no-constant-condition
    while (true) {
      hoveredIndex += interval;
      if (hoveredIndex === options.length) {
        hoveredIndex = 0;
      } else if (hoveredIndex < 0) {
        hoveredIndex = options.length - 1;
      }
      if (this.isValidOptionForSelection(options[hoveredIndex])) {
        break;
      }
    }
    this.hoverItemAtIndex(hoveredIndex);
  }
  hoverItemById(id) {
    const {
      options
    } = this.props;
    const index = options.findIndex(option => option.id === id);
    if (index !== -1) {
      this.hoverItemAtIndex(index);
    }
  }
  hoverItemAtIndex(index) {
    const {
      options
    } = this.props;
    if (!options.find(this.isValidOptionForSelection)) {
      return;
    }
    if (this.optionsContainerRef) {
      const hoveredOption = this.optionsContainerRef.childNodes[index];
      const hoveredOptionHeight = hoveredOption.offsetHeight;
      const hoveredOptionTop = hoveredOption.offsetTop - 1;
      const {
        scrollTop: optionsContainerScrollTop,
        clientHeight: optionsContainerClientHeight
      } = this.optionsContainerRef;

      // If hovered option is not visible
      if (!(optionsContainerScrollTop <= hoveredOptionTop && optionsContainerScrollTop + optionsContainerClientHeight > hoveredOptionTop + hoveredOptionHeight)) {
        if (this.optionsContainerRef.scrollTop < hoveredOptionTop) {
          this.optionsContainerRef.scrollTop = hoveredOptionHeight + hoveredOptionTop - optionsContainerClientHeight;
        } else {
          this.optionsContainerRef.scrollTop = hoveredOptionTop;
        }
      }
    }
    this.setHoveredIndex(index);
  }
  getOptionDOMid(option) {
    const optionsContainerId = this.props.optionsContainerId;
    return optionsContainerId ? `${optionsContainerId}_option-${option.id}` : null;
  }
  getSelectedOption() {
    const {
      options
    } = this.props;
    const {
      hoveredIndex
    } = this.state;
    const isValidIndex = hoveredIndex >= 0 && hoveredIndex < options.length;
    return isValidIndex ? {
      ...options[hoveredIndex],
      _DOMid: this.getOptionDOMid(options[hoveredIndex])
    } : null;
  }
  onKeyDown(eventKey, evt) {
    switch (eventKey) {
      case 'ArrowUp':
        {
          evt.preventDefault();
          return this.hoverNextItem(-1);
        }
      case 'ArrowDown':
        {
          evt.preventDefault();
          return this.hoverNextItem(1);
        }
      case 'ArrowLeft':
      case 'ArrowRight':
        {
          return;
        }
    }
  }
  onMouseMove(evt) {
    this.mouseCoords.screenX = evt.screenX;
    this.mouseCoords.screenY = evt.screenY;
  }
  onMouseDown(e) {
    const {
      onMouseDown
    } = this.props;
    onMouseDown && onMouseDown(e);
  }
  onMouseEnter(evt, index) {
    if (this.mouseCoords.screenX !== evt.screenX || this.mouseCoords.screenY !== evt.screenY) {
      this.setHoveredIndex(index);
    }
  }
  render() {
    const {
      fixedHeader,
      fixedFooter,
      options,
      selectedIds,
      onOptionClick,
      optionsContainerId,
      className,
      role = 'menu',
      noResultsText
    } = this.props;
    const {
      hoveredIndex
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      className: st(classes.root, className),
      "data-hook": this.props['data-hook'],
      onMouseMove: this.onMouseMove,
      onMouseDown: this.onMouseDown
    }, fixedHeader, /*#__PURE__*/React.createElement("div", {
      role: role,
      className: classes.optionsContainer,
      id: optionsContainerId,
      ref: optionsContainer => this.optionsContainerRef = optionsContainer
    }, !(options != null && options.length) && !!noResultsText && /*#__PURE__*/React.createElement(Text, {
      role: "alert",
      priority: "secondary",
      className: classes.noResultsText
    }, noResultsText), (options || []).map((option, index) => /*#__PURE__*/React.createElement(CoreDropdownOption, {
      className: classes.dropdownOption,
      dataHook: "option",
      key: option.id,
      id: this.getOptionDOMid(option),
      option: option,
      isHovered: hoveredIndex === index,
      isSelected: (selectedIds || []).includes(option.id),
      role: role === 'listbox' ? 'option' : 'menuitem',
      onClickHandler: this.isValidOptionForSelection(option) ? () => onOptionClick(option) : undefined,
      onMouseEnterHandler: this.isValidOptionForSelection(option) ? evt => this.onMouseEnter(evt, index) : undefined,
      onMouseLeaveHandler: () => {
        this.setHoveredIndex(NOT_HOVERED_INDEX);
      }
    }))), fixedFooter);
  }
}
_defineProperty(CoreDropdownContent, "displayName", 'CoreDropdownContent');
//# sourceMappingURL=CoreDropdownContent.js.map